import React, { Component } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { user_incentives_list } from "../../user/user.api";
import "./tenders.css";
import { useEffect } from "react";
import { useState } from "react";

function Careers(props) {
  const [data, setData] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  const result = servInstance?.substring(0, servInstance.length - 4);

  useEffect(() => {
    user_incentives_list().then((res) => {
      setData(res?.data);
    });
  }, []);
  const handleNav = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  const handleDownloadFile = (fileUrl) => {
    if (!fileUrl) return;
    const fullFileUrl = `${result}${fileUrl}`;
    window.open(fullFileUrl, "_blank");
  };
  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>{props.state.language === "ma" ? "സാമ്പത്തിക സഹായവും പ്രോത്സാഹനങ്ങളും" : "Financial Support and Incentives"}</h3>
        </div>
      </div>
      <div className="container p-50">
        <div className="bg-white">
          <div className="row tender-box">
            {data.length > 0 ? (
              data.map((item, index) => (
                <div className="bg-tender p-30" key={index}>
                  <div className="tender-title mb-2">
                    <p className="head">
                      <u>{props.state.language === "ma"
                        ? item?.title_ma ?? ""
                        : item?.title ?? ""}</u>
                    </p>
                  </div>
                  <div className="tender-datas">
                    <div className="col-lg-2 col-md-12 col-sm-12 label">
                      <p>
                        {props.state.language === "ma"
                          ? "വിവരണം"
                          : "Description"}
                      </p>
                    </div>
                    <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                      <p>
                        {props.state.language === "ma"
                          ? ReactHtmlParser(item?.description_ma) ?? ""
                          : ReactHtmlParser(item?.description) ?? ""}
                      </p>
                    </div>
                  </div>
                  {item.link && item.link !== "null" && (
                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                        </p>
                      </div>
                      <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf">
                        <p className="blink_me">
                          <CustomIcons iconName={"hand"} />
                        </p>
                        <span>
                          &nbsp;
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNav(item?.link);
                            }}
                            className="break_link"
                          >
                            {props.state.language === "ma"
                              ? "ഇവിടെ ക്ലിക്ക് ചെയ്യൂ"
                              : "Click Here"}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}
                  {item?.file && item?.file !== "storage/" && (
                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "ഡൗൺലോഡ്"
                            : "Download"}
                        </p>
                      </div>
                      <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf align-items-center">
                        <p className="blink_me">
                          <CustomIcons iconName={"hand"} />
                        </p>
                        <span>
                          &nbsp;
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDownloadFile(item?.file);
                            }}
                            className="break_link"
                          >
                            {props.state.language === "ma"
                              ? "ഫയൽ ഡൗൺലോഡ് ചെയ്യൂ"
                              : "Download Document"}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="no-data">
                <img src="resources/img/no1.png" alt="no data" />
                <h4>No Records Found..!!</h4>
              </div>
            )}
          </div>
        </div>
      </div>

    </>
  );
}
export default Careers;
